import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
// Service
import { BroadcastService, ObjectUtils } from '@cv-invision/core';
import { ViewsService } from '../../../../../services/views.service';
import { LayoutRenderService } from '../../../services/layout-render.service';
// Model
import { LayoutRenderLayoutItem } from '../../../models/cv-layout-render.model';
import { TabsSectionButtonOptions } from '../../models/component-options/tabs-section-button.options';
import { DROPDOWN_BUTTON_ITEM_TYPE, DropdownButtonItem } from '@cv-invision/cv.component-library.ux';
import { TabSectionMode } from '../../models/component-options/tabs-section.options';
import { ComponentList } from '../../../models/components.enum';

@Component({
	selector: 'cv-schema-render-tab-section-button',
	templateUrl: './tabs-section-button.component.html',
})
export class TabsSectionButtonComponent implements OnInit, OnDestroy {
	@Input() data: any;
	@Input() layoutNode = new LayoutRenderLayoutItem();
	@ViewChild('dropdownButton', {static: false}) dropdownButton: any;
	private atComponentDestroy = new Subject();

	public options = new TabsSectionButtonOptions();
	public path: string | null;
	public tabSectionMode = TabSectionMode


	public dropdownOptions: Array<DropdownButtonItem>;
	public buttonLabel = '';

	get isEditable(): boolean {
		return this.layoutRenderService.extraData.isEditing;
	}

	constructor(
		protected broadcastService: BroadcastService,
		private layoutRenderService: LayoutRenderService,
		protected viewsService: ViewsService
	) {
	}

	ngOnInit(): void {
		this.options = { ...this.options, ...this.layoutNode.options };

		// Add Button Label
		this.buttonLabel = this.layoutNode.title;

		// For Dropdowns
		if (this.options.tabSectionMode === this.tabSectionMode.DROPDOWN) {
			this.options.dropdownOptions.forEach((item: any) => {
				item.type = DROPDOWN_BUTTON_ITEM_TYPE.OPTION;
			});
			// CC the Options
			this.dropdownOptions = this.options.dropdownOptions;
		}
	}

	/**
	 * On Execute Action
	 * @param $event
	 */
	onExecuteAction(event: { index: number; item: DropdownButtonItem }): void {
		this.layoutRenderService.componentBroadcast.next({
			eventType: event.item.data.eventType,
			jsonPath: this.data.data._Path,
			metaData: ObjectUtils.recursiveDeepCopy(event.item.data.componentData),
			component: ComponentList.TABS_SECTION_BUTTON
		});
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
